import * as React from 'react';
import { Form, Label } from 'semantic-ui-react';
import { Description } from 'src/componentes/semantic-ui-extended';

interface Props {
    /** Etiqueta principal que aparece encima de él. */
    label: string;

    /** La descripción aparece debajo del campo. */
    description?: string;

    /** Coloca un asterísco junto a la etiqueta y marca el campo como obligatorio. */
    required?: boolean;

    /** Marca el campo como desactivado de modo que no se puede escribir en él. */
    disabled?: boolean;

    /**
     * Determina si el campo está o no en estado de error. En estado de error el campo
     * se muestra en rojo y la descripción se reemplaza por una etiqueta con el mensaje
     * de error *erroMessage* si se proporciona.
     */
    error?: boolean;

    /** Mensaje que se mostrará debajo del campo en caso de error. */
    errorMessage?: string;

    /** Componente principal que se renderizará dentro del campo. */
    children: React.ReactNode;
}

const fieldStyle: React.CSSProperties = {
    marginBottom: '30px',
};

const Field: React.FunctionComponent<Props> = props => {
    const { label, description, required, disabled, error, errorMessage, children } = props;

    const hayMensajeDeError = !!errorMessage && errorMessage.length > 0;
    const hayDescripcion = !!description && description.length > 0;

    const errorComponente = (
        <Label color='red' pointing>
            {errorMessage}
        </Label>
    );

    const descripcionComponente = <Description content={description} />;

    return (
        <Form.Field required={required} error={error} style={fieldStyle} disabled={disabled}>
            <label>{label}</label>

            {children}

            {error && hayMensajeDeError ? errorComponente : hayDescripcion && descripcionComponente}
        </Form.Field>
    );
};

export default Field;



// WEBPACK FOOTER //
// ./src/componentes/semantic-ui-extended/Field/index.tsx